// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a1f716b7b2e2f86b797f","655":"00619a17685039dee4c1"}[chunkId] + ".js";
};